/**
 * CSV Import Button Component
 *
 * Button for importing accounts from CSV file.
 */

import React from 'react';
import { Upload } from 'lucide-react';
import { Button } from '@/shared/ui/components/Button';
import type { CsvImportState } from '../model/types';

interface CsvImportButtonProps {
  state: CsvImportState;
  className?: string;
}

export const CsvImportButton: React.FC<CsvImportButtonProps> = ({ state, className }) => {
  const { isImporting, handleImport } = state;

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={handleImport}
      disabled={isImporting}
      className={className}
    >
      <Upload className="w-4 h-4 mr-1" />
      {isImporting ? 'CSV 가져오는 중...' : 'CSV 가져오기'}
    </Button>
  );
};

CsvImportButton.displayName = 'CsvImportButton';
